"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebsocketChannels = exports.EWebsocketChannels = void 0;
var EWebsocketChannels;
(function (EWebsocketChannels) {
    EWebsocketChannels["everything"] = "everything";
    EWebsocketChannels["dbUpdates"] = "dbUpdates";
    EWebsocketChannels["health"] = "health";
    EWebsocketChannels["sendingStatusUpdates"] = "sendingStatusUpdates";
    EWebsocketChannels["providersStatesUpdates"] = "providersStatesUpdates";
})(EWebsocketChannels || (exports.EWebsocketChannels = EWebsocketChannels = {}));
/**
 * @deprecated Используйте EWebsocketChannels
 */
var WebsocketChannels;
(function (WebsocketChannels) {
    WebsocketChannels["everything"] = "everything";
    WebsocketChannels["dbUpdates"] = "dbUpdates";
    WebsocketChannels["health"] = "health";
    WebsocketChannels["sendingStatusUpdates"] = "sendingStatusUpdates";
    WebsocketChannels["providersStatesUpdates"] = "providersStatesUpdates";
})(WebsocketChannels || (exports.WebsocketChannels = WebsocketChannels = {}));
//# sourceMappingURL=websocket.enum.js.map